import {Action} from "@ngrx/store";

export const GET_VP_ZONE_CREATED_RESPONSE = '[Website] Get VP Zone Created Response';
export const GET_VP_ZONE_CREATED_RESPONSE_SUCCESS = '[Website] Get VP Zone Created Response Success';
export const GET_VP_ZONE_CREATED_RESPONSE_FAIL = '[Website] Get VP Zone Created Response Fail';

export class GetVPZoneCreatedResponse implements Action {
  readonly type = GET_VP_ZONE_CREATED_RESPONSE;
}

export class GetVPZoneCreatedResponseSuccess implements Action {
  readonly type = GET_VP_ZONE_CREATED_RESPONSE_SUCCESS;
  constructor(public payload: any) {}
}

export class GetVPZoneCreatedResponseFail implements Action {
  readonly type = GET_VP_ZONE_CREATED_RESPONSE_FAIL;
  constructor(public payload: string) {}
}

export type WebsiteZoneAction = GetVPZoneCreatedResponse | GetVPZoneCreatedResponseSuccess | GetVPZoneCreatedResponseFail;
